import { TweenMax } from "gsap/TweenMax";
// $(window).on('scroll', function() {
//   let s = $(window).scrollTop();
//   let rate = 800;
//   let target = $('.top-bgMovie');

//   let opacity = 1 - (s / rate) >= 0 ? 1 - (s / rate) : 0;
//   console.log(opacity)
//   $(target).css({
//     'opacity': opacity
//   })

// }).trigger('scroll');


// import { TweenMax, Power2, TimelineLite } from "gsap/TweenMax";
// import parallax from '../../plugins/parallax.js';

// import luxy from 'luxy.js';



//慣性スクロール量を取得
// tick();
let offset = 0;
let s = 0;
let rate = 500;
let target = $('.top-bgMovie');
let video = document.querySelector('.js-video-player-content');
// function tick() {
//   requestAnimationFrame(tick)
//   offset += ($(window).scrollTop() - offset) * 0.08;

//   s = Math.round(offset * 100) / 100

//   let opacity = 1 - (s / rate) >= 0 ? 1 - (s / rate) : 0;

//   $(target).css({
//     'opacity': opacity
//   })


// }

if(video) {

  TweenMax.to({}, .001, {
    repeat: -1,
    onRepeat: () => {
  
      offset += ($(window).scrollTop() - offset) * 0.08;
  
      s = Math.round(offset * 100) / 100
  
      let opacity = 1 - (s / rate) >= 0 ? 1 - (s / rate) : 0;
  
      if(opacity >= 0.1) {
        video.play()
      } else {
        video.pause()
      }
  
      $(target).css({
        'opacity': opacity
      })
    }
  });
}


// var MiniMasonry = function(conf) {
//   this._sizes = [];
//   this._columns = [];
//   this._container = null;
//   this._count = null;
//   this._width = 0;
//   this._gutter = 0;

//   this._resizeTimeout = null,

//   this.conf = {
//       baseWidth: 255,
//       gutter: 10,
//       container: null,
//       minify: true
//   };

//   this.init(conf);

//   return this;
// }

// MiniMasonry.prototype.init = function(conf) {
//   console.log("hoge");
//   for (var i in this.conf) {
//       if (conf[i] != undefined) {
//           this.conf[i] = conf[i];
//       }
//   }
//   this._container = document.querySelector(this.conf.container);
//   if (!this._container) {
//       throw new Error('Container not found or missing');
//   }
//   window.addEventListener("resize", this.resizeThrottler.bind(this));

//   this.layout();
// };

// MiniMasonry.prototype.reset = function() {
//   this._sizes = [];
//   this._columns = [];
//   this._count = null;
//   this._width = this._container.clientWidth;
//   var minWidth = ((2 * this.conf.gutter) + this.conf.baseWidth);
//   if (this._width < minWidth) {
//       this._width = minWidth;
//       this._container.style.minWidth = minWidth + 'px';
//   }
//   this._gutter = this.conf.gutter;
//   if (this._width < 530) {
//       this._gutter = 5;
//   }
// };

// MiniMasonry.prototype.layout =  function() {
//   if (!this._container) {
//       console.error('Container not found');
//       return;
//   }
//   this.reset();

//   //Computing columns width
//   this._count = Math.floor((this._width - this._gutter) / (this.conf.baseWidth + this.conf.gutter));
//   var width   = ((this._width - this._gutter) / this._count) - this._gutter;

//   for (var i = 0; i < this._count; i++) {
//       this._columns[i] = 0;
//   }


//   //Saving children real heights
//   var children = this._container.querySelectorAll(this.conf.container + ' > *');
//   for (var k = 0;k< children.length; k++) {
//       this._sizes[k] = children[k].clientHeight;
//   }

//   //If more columns than children
//   var initialLeft = this._gutter;
//   if (this._count > this._sizes.length) {
//       initialLeft = (((this._width - (this._sizes.length * width)) - this._gutter) / 2) - this._gutter;
//   }

//   //Computing position of children
//   for (var index = 0;index < children.length; index++) {
//       var shortest = this.conf.minify ? this.getShortest() : this.getNextColumn(index);

//       children[index].style.width = Math.round(width) + 'px';
//       var x = initialLeft + ((width + this._gutter) * (shortest));
//       var y = this._columns[shortest];


//       children[index].style.transform = 'translate3d(' + Math.round(x) + 'px,' + Math.round(y) + 'px,0)';

//       this._columns[shortest]  += this._sizes[index] + this.conf.gutter;//margin-bottom
//   }

//   this._container.style.height = this._columns[this.getLongest()] + 'px';
// };

// MiniMasonry.prototype.getNextColumn = function(index) {
//   return index % this._columns.length;
// };

// MiniMasonry.prototype.getShortest = function() {
//   var shortest = 0;
//   for (var i = 0; i < this._count; i++) {
//       if (this._columns[i] < this._columns[shortest]) {
//           shortest = i;
//       }
//   }

//   return shortest;
// };

// MiniMasonry.prototype.getLongest = function() {
//   var longest = 0;
//   for (var i = 0; i < this._count; i++) {
//       if (this._columns[i] > this._columns[longest]) {
//           longest = i;
//       }
//   }

//   return longest;
// };

// MiniMasonry.prototype.resizeThrottler = function() {
//   // ignore resize events as long as an actualResizeHandler execution is in the queue
//   if ( !this._resizeTimeout ) {

//       this._resizeTimeout = setTimeout(function() {
//           this._resizeTimeout = null;
//           //IOS Safari throw random resize event on scroll, call layout only if size has changed
//           if (this._container.clientWidth != this._width) {
//               this.layout();
//           }
//          // The actualResizeHandler will execute at a rate of 15fps
//       }.bind(this), 66);
//   }
// }

// var masonry = new MiniMasonry({
//   container: '.gallery-content',
//   gutter: 0
// });


class MasonryAreaHeight {
  constructor() {
    this.height = [];
    this.settings = {
      row: 3,
      wrapper: ".js-masonry-content",
      target: ".js-masonry-item"
    }
  }

  init(options) {
    this.setup(options);
    this.setStyle();
    this.setBreakElm();
    this.getHeight();
    this.setHeight();
    this.attachEvent();
  }

  setup(options) {
    // this.settings = $.extend({
    //   inertiaScrollWrap: this.settings.inertiaScrollWrap,
    //   inertiaScrollSpeed: this.settings.inertiaScrollSpeed
    // }, options || {});
    this.settings = Object.assign({
      row: this.settings.row,
      wrapper: this.settings.wrapper,
      target: this.settings.target
    }, options || {});
  }

  setBreakElm() {
    for (var i = 1; i < this.settings.row; i++) {
      $(`${this.settings.wrapper}`).append(`<span class="is-masonry-break" style="order: ${i};"></span>`)
    }
  }


  setStyle() {
    $(`${this.settings.target}`).css({
      'width': `${100 / this.settings.row}%`
    })
    for (const t of document.querySelectorAll(this.settings.target)) {
      // console.log($(t).find('.js-inner').height())
      $(t).css({
        'height': 'auto'
      })
      $(t).css({
        'height': $(t).find('.js-masonry-item-content').height() + "px"
      })
    }
    for (var i = 1; i < this.settings.row + 1; i++) {
      $(`${this.settings.target}:nth-child(${this.settings.row}n + ${i})`).css({
        'order': `${i}`
      })
    }
  }

  getHeight() {
    for (var i = 1; i < this.settings.row + 1; i++) {
      let h = 0;
      // console.log(i);
      $(`${this.settings.target}:nth-child(${this.settings.row}n + ${i})`).not('.break').each(function () {
        // $(this).css({ opacity: 0.6 });
        h += $(this).height();
        // console.log(h);
        return h;
      })
      this.height.push(h)
      // console.log($(`${this.settings.target}:nth-child(${this.settings.row}n + ${i})`));
      // console.log(this.height);
    }
  }

  setHeight() {
    $(`${this.settings.wrapper}`).css({
      'height': Math.max(...this.height) + 0.1 + 'px'
    })
    // console.log(Math.max(...this.height));
    this.height = [];

  }

  attachEvent() {
    $(window).on('scroll load resize', () => {
      this.setStyle();
      this.getHeight();
      this.setHeight();
    })
  }

}


let hoge = new MasonryAreaHeight();

$(window).on("resize", function () {
  var r = 4;
  var w = $(window).width();
  // console.log(w)

  if (w > 768) {
    r = 4;
  } else if (w <= 768 && w >= 599) {
    r = 2;
  } else {
    r = 1;
  }
  hoge.init({
    row: r,
    wrapper: '.gallery-content',
    target: '.gallery-content-item'
  })
  hoge.setBreakElm()
}).trigger("resize");

// $(window).on('resize', function () {
//   var h1 = 0;

//   $('.gallery-content-item:nth-child(3n + 1)').each(function () {
//     $(this).css({ opacity: 0.6 });
//     h1 += $(this).height();
//     // console.log(h1);
//   })
//   $('.gallery-content-item:nth-child(3n + 2)').each(function () {
//     $(this).css({ opacity: 0.2 });
//   })
//   $('.gallery-content-item:nth-child(3n + 3)').each(function () {
//     $(this).css({ opacity: 0.8 });
//   })

//   $('.gallery-content').css({
//     'height': h1 + 1 + 'px'
//   })

// })